import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { MarketProvider } from './contexts/MarketContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { BenchmarkProvider } from './contexts/BenchmarkContext';
import NotificationContainer from './components/common/NotificationContainer';
import AppRoutes from './routes';

// 🔍 Ativar debug de timers para detectar problema dos 120 segundos
if (process.env.NODE_ENV === 'development') {
  import('./utils/debug');
}

// Criar o cliente de consulta para React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

/**
 * Componente principal da aplicação que configura os providers
 */
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <NotificationProvider>
          <AuthProvider>
            <MarketProvider>
              <BenchmarkProvider>
                <NotificationContainer />
                <AppRoutes />
              </BenchmarkProvider>
            </MarketProvider>
          </AuthProvider>
        </NotificationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App; 